import reduxApi from 'redux-api';
import { adapterJquery } from './ApiHelpers';


export default reduxApi({
  googleFonts: {
    url: 'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyAi87bNwnZLXM9urTBw6Qcg4tNb_-IAiak',
    helpers: {
      get(params = {}) {
        return [params, { 
           method: 'GET' 
        }];
      }
    }
  },
  awesomeFonts: {
    url: 'https://s3.amazonaws.com/pixiebot/fonts.json',
    helpers: {
      get(params = {}) {
        return [params, { 
           method: 'GET' 
        }];
      }
    }
  },
  indexSynonyms: {
    url: 'https://raw.githubusercontent.com/johnpcarty/Thesaurus-of-Job-Titles/master/synonym_job_titles_for_index.txt',
    helpers: {
      get(params = {}) {
        return [params, { 
           method: 'GET' 
        }];
      }
    }
  },
  searchSynonyms: {
    url: 'https://raw.githubusercontent.com/johnpcarty/Thesaurus-of-Job-Titles/master/synonym_job_titles_for_search.txt',
    helpers: {
      get(params = {}) {
        return [params, { 
           method: 'GET' 
        }];
      }
    }
  }  
}).use('fetch', adapterJquery);
